import { jsx as _jsx } from "react/jsx-runtime";
import { useSnackbar } from 'notistack';
const InnerSnackbarUtilsConfigurator = (props) => {
    props.setUseSnackbarRef(useSnackbar());
    return null;
};
let useSnackbarRef;
const setUseSnackbarRef = (useSnackbarRefProp) => {
    useSnackbarRef = useSnackbarRefProp;
};
export const SnackbarUtilsConfigurator = () => {
    return _jsx(InnerSnackbarUtilsConfigurator, { setUseSnackbarRef: setUseSnackbarRef });
};
export const toaster = {
    success(msg) {
        this.toast(msg, 'success');
    },
    warning(msg) {
        this.toast(msg, 'warning');
    },
    info(msg) {
        this.toast(msg, 'info');
    },
    error(msg) {
        this.toast(msg, 'error');
    },
    toast(msg, variant = 'default') {
        useSnackbarRef.enqueueSnackbar(msg, { variant });
    },
};
